export const TIP_WIDGET_TEXTS = {
    TIP_CTA: "Tip",
    LOAD_DELAY_MS: 1000,
    CLOSE_LABEL: "Collapse tip widget",
    PAYMENT_OPTION_LABEL: "Tip using {0}",
    SINGLE_PAYMENT_OPTION_CTA: "Tip via {0}",
    MAX_PAYMENT_OPTIONS: 4,
};

export const TIP_WIDGET_ANIMATION = {
    SLIDE_UP_DURATION_MS: 400,
    SLIDE_UP_EASING: "cubic-bezier(0.25, 1, 0.5, 1)",
    MORPH_DURATION_MS: 350,
    MORPH_EASING: "ease-in-out",
};
